/**
 * Function to calculate the quarter of the year from the given month.
 * @param month - The month as a number (1-12).
 * @returns The quarter of the year (1-4).
 */
function getQuarterFromMonth(month: number): number {
  if (month < 1 || month > 12) {
    throw new Error("Month must be between 1 and 12");
  }

  if (month >= 1 && month <= 3) {
    return 1;
  } else if (month >= 4 && month <= 6) {
    return 2;
  } else if (month >= 7 && month <= 9) {
    return 3;
  } else {
    return 4;
  }
}

export { getQuarterFromMonth };
